import { cn } from '@/shared/lib/cn';

interface LogoProps {
  /** 'full' = wordmark completo (lockup) · 'icon' = só o ícone (favicon) */
  variant?: 'full' | 'icon';
  /** 'light' = wordmark colorido pra fundo claro · 'dark' = wordmark branco pra fundo escuro */
  tone?: 'light' | 'dark';
  /** Altura do lockup em px (default 34 — alinhado com mockups) */
  height?: number;
  className?: string;
}

/**
 * Lockup oficial ChatPlus — assets em `apps/web/public/`.
 * - logo-wordmark.png → tone='light' (fundo claro)
 * - logo-wordmark-white.png → tone='dark' (fundo escuro)
 * - favicon.png → variant='icon'
 *
 * A LARGURA vem calculada pela proporção do arquivo, não `auto`: com `auto`
 * a imagem ocupa 0px até baixar, e no topo o menu (logo depois do logo)
 * nascia encostado à esquerda e pulava pro lugar a cada F5 (dono,
 * 19/out/2026). Trocou o arquivo? Atualize a proporção aqui.
 */
const PROPORCAO_WORDMARK = 970 / 281;
const PROPORCAO_ICONE = 271 / 281;

export function Logo({ variant = 'full', tone = 'light', height = 34, className }: LogoProps) {
  if (variant === 'icon') {
    return (
      <img
        src="/favicon.png"
        alt="ChatPlus"
        height={height}
        width={Math.round(height * PROPORCAO_ICONE)}
        style={{ height: `${height}px`, width: `${Math.round(height * PROPORCAO_ICONE)}px` }}
        className={cn('block', className)}
      />
    );
  }

  const src = tone === 'dark' ? '/logo-wordmark-white.png' : '/logo-wordmark.png';
  const largura = Math.round(height * PROPORCAO_WORDMARK);
  return (
    <img
      src={src}
      alt="ChatPlus"
      height={height}
      width={largura}
      style={{ height: `${height}px`, width: `${largura}px` }}
      className={cn('block', className)}
    />
  );
}
